/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * One managed tool's enforcement state on a device.
 */
export type ManagedDeviceTool = {
  /**
   * True when a problem the user can fix is blocking this tool.
   */
  actionRequired: boolean;
  /**
   * Times the agent restored what it owns in this tool since drift_counting_since. Omitted when not measured.
   */
  driftCorrections?: number | undefined;
  /**
   * Class of a reconcile error: permission_denied, not_found, invalid_config, or unknown.
   */
  errorKind?: string | undefined;
  /**
   * Enforcement layer: user, managed, off, or unknown.
   */
  layer: string;
  /**
   * Reconcile outcome: armed, pending, skipped (tool not installed), error, unmanaged, or unknown.
   */
  outcome: string;
  /**
   * Why a pending tool is not enforcing yet: privileged_writer_not_ready, plugin_bundle_not_cloned, or unknown.
   */
  pendingReason?: string | undefined;
  /**
   * True when the tool loads the agent's changes only after it restarts.
   */
  restartRequired: boolean;
  /**
   * Stable tool id, e.g. claude_code.
   */
  tool: string;
};

/** @internal */
export const ManagedDeviceTool$inboundSchema: z.ZodMiniType<
  ManagedDeviceTool,
  unknown
> = z.pipe(
  z.object({
    action_required: z.boolean(),
    drift_corrections: z.optional(z.int()),
    error_kind: z.optional(z.string()),
    layer: z.string(),
    outcome: z.string(),
    pending_reason: z.optional(z.string()),
    restart_required: z.boolean(),
    tool: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "action_required": "actionRequired",
      "drift_corrections": "driftCorrections",
      "error_kind": "errorKind",
      "pending_reason": "pendingReason",
      "restart_required": "restartRequired",
    });
  }),
);

export function managedDeviceToolFromJSON(
  jsonString: string,
): SafeParseResult<ManagedDeviceTool, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ManagedDeviceTool$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ManagedDeviceTool' from JSON`,
  );
}
